// we are storing the token in the local storage its using only when we use auth token instead of bearer token

const GetAccessToken = () => {
  let accessToken = "";
  if (sessionStorage.getItem("token")) {
    accessToken = sessionStorage.getItem("token");
  }
  return accessToken;
};

export { GetAccessToken };
